import { createStyles } from "@material-ui/core";
import { globalStyles } from "../../../styles/globalStyles";

export const styles = createStyles({
  ...globalStyles,
  title: {
    marginTop: 30
  }
});